import {useParams} from 'react-router-dom';
import {UserAffiliationRolesTable} from '../../../../../../../components/user-affiliation-roles-table/user-affiliation-roles-table';

export default function CaregiverAffiliationsSystemAdministratorOfficeScreen() {
  const {id}: {id?: string} = useParams();

  return <UserAffiliationRolesTable userId={id || ''} />;
}
